<template>
  <div class="customerGroup">
    <van-form ref="form">
      <van-cell required title="所属分组" class="group_share" ref="group_share">
        <template #default>
          <van-field class="users_field" v-model="group_str" placeholder="请输入..." name="groupName" ref="users_field" :rules="[{ required: true, message: '请选择所属分组' }]">
            <template #input>
              <div class="text_wrap usersWrap">
                <div class="addNew" v-show="dialogOpen" @click="creatNewGroup"><van-icon name="plus" /><span>新建分组</span></div>
                <div class="select_group" v-show="dialogOpen">
                  <span
                    v-for="item in groupNameArr"
                    :key="item.id"
                    @click="selectGroup(item)"
                    :style="{ color: item.id === groupId ? '#277FFF' : '#333', backgroundColor: item.id === groupId ? '#E9F2FF' : 'transparent' }"
                    >{{ item.title }}</span
                  >
                </div>
              </div>
            </template>
          </van-field>
        </template>
        <template #icon>
          <div class="right_arrow" @click="openSelect">
            <span v-show="!group_str">请选择</span>
            <span v-show="group_str" style="color: #333333">{{ group_str }}</span>
            <van-icon name="arrow" />
          </div>
        </template>
      </van-cell>

      <van-cell required title="话术名称">
        <template #default>
          <van-field
            style="padding: 3px; margin-bottom: -3px"
            v-model="produreName"
            name="produreName"
            type="text"
            maxlength="30"
            :autocomplete="false"
            show-word-limit
            placeholder="请输入..."
            :rules="[{ required: true, message: '请输入话术名称' }]"
          />
        </template>
      </van-cell>

      <van-cell title="消息内容" :required="required">
        <template #default>
          <van-field
            v-model="textType.content"
            name="messageWord"
            type="textarea"
            rows="3"
            autosize
            maxlength="1500"
            show-word-limit
            placeholder="请输入..."
            :rules="[{ required: true, message: '请输入消息内容或上传附件' }]"
          >
            <!--            <template #right-icon>-->
            <!--              <span class="error_text">请输入消息内容或上传附件</span>-->
            <!--            </template>-->
          </van-field>
          <dl class="speare_line"></dl>
          <add-file @isFixedBottom="isFixedBottom" @listArr="listArr" :produreList="qWediaAttachmentsDataList"></add-file>
        </template>
      </van-cell>
    </van-form>

    <!--    最下面-->
    <div class="bottom_word">
      <p>注：</p>
      <p>1. 图片：支持jpg、png格式，大小不超过10MB；</p>
      <p>2. 视频：支持mp4、avi、wmv、rmvb、mov、m4v，大小不超过10MB；</p>
      <p>3. 文件：支持word、pdf、excel、txt、ppt、rar、html格式，大小不超过20MB；</p>
    </div>

    <div class="fixed_bottom fixed_horizo_center" v-show="isFixedBottoms">
      <div class="button_bottom">
        <dl @click="resetUser">取消</dl>
        <dl
          @click="ensureComfirm"
          ref="ensureConfirm"
          :style="{ opacity: groupId && (textType.content.length > 0 || this.qWediaAttachmentsDataList.length) && produreName ? 1 : 0.5 }"
        >
          确认
        </dl>
      </div>
    </div>

    <!--添加分组-->
    <van-dialog
      v-model="groupDialog"
      title="新加分组"
      show-cancel-button
      confirm-button-color="#277FFF"
      :before-close="beforeClose"
      @confirm="addNewGroupConfirm"
      @cancel="addNewGroupCancel"
    >
      <van-form ref="addNewGroup">
        <van-field type="text" maxlength="16" show-word-limit v-model="addGroupName" placeholder="请输入分组名称" class="addNewGroup" />
        <p class="error_warn" v-show="showError">请输入分组名称</p>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import newReply from "./js/newReply";
export default newReply;
</script>

<style lang="less" scoped>
@import "css/index";
.group_share {
  position: relative;
  .users_field {
    display: none;
    /deep/.van-field__control--custom {
      min-height: 0;
    }
    .addNew {
      color: #277fff;
      font-size: 28px;
      display: flex;
      margin-top: 8px;
      align-items: center;
      padding-left: 14px;
      line-height: 60px;
    }
    .select_group {
      font-size: 28px;
      color: #333333;
      display: flex;
      flex-direction: column;
      span {
        padding-left: 14px;
        line-height: 64px;
      }
    }
  }
}
.currentOpen::after {
  position: absolute;
  top: 78px;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #d8d8d8;
  z-index: 101;
}
/deep/.error_text {
  color: #ee0a24;
  font-size: 24px;
  width: 100%;
  position: absolute;
  top: 75px;
  z-index: 100;
  left: 0;
}
.van-dialog {
  .van-form {
    padding: 30px 40px;
    .addNewGroup {
      border: 1px solid #d8d8d8;
      padding: 0;
      /deep/.van-field__control {
        font-size: 18px;
        color: #333333;
        outline: none;
        padding: 10px 58px 10px 14px;
        //border-top: none;
        border-radius: 10px;
      }
      /deep/.van-field__word-limit {
        color: #666666;
        font-size: 16px;
        position: absolute;
        bottom: 19px;
        right: 12px;
      }
    }
  }
  /deep/.error_warn {
    font-size: 14px;
    padding-left: 2px;
    margin: -6px 0 10px 0;
    position: relative;
    z-index: 11;
    color: #e4393c;
  }
}
</style>
